(function () {
    const $body = $('body');

    var fieldsCtrl = {
        container: null,
        $wrapper: null,
        $toggle: null,
        $form: null,
        $terms: null,
        $markAll: null,
        maxClone: 2,

        init: function () {
            fieldsCtrl.$toggle = $('.reproducible');
            fieldsCtrl.$wrapper = $('.reproducible__wrapper');
            fieldsCtrl.container = '.reproducible__container'; // Support for the legacy emails and phones used in account page

            //fieldsCtrl.check.terms();
            fieldsCtrl.control();

            const $lastTerm = fieldsCtrl.$wrapper.children('.reproducible').length;
            fieldsCtrl.check.lastClone($lastTerm);

            fieldsCtrl.accessibility.init();
            fieldsCtrl.additionalControls();
        },
        accessibility: {
            init: function () {
                this.radioCheckbox();
                if ($('.force--disabled').length === 0) {
                    this.selectBox();
                }
                this.buttons.init();
                this.range();
            },
            radioCheckbox: function () {
                const radioCheckboxSelector =
                    '.radio--primary, .radio--secondary, .checkbox--primary, .checkbox--secondary';
                $(document)
                    .on('mousedown', radioCheckboxSelector, function (event) {
                        var $this = $(this);
                        $this.attr({tabindex: 0});
                    })
                    .on('mouseup', radioCheckboxSelector, function (event) {
                        const $this = $(this);
                        $this.removeAttr('tabindex');
                        if ($this.hasClass('withInput')) {
                            $this.find('input[type=email], input[type=text]').focus();
                        } else {
                            $this.find('input[type=radio], input[type=checkbox]').focus();
                        }
                    });
            },
            selectBox: function () {
                // JCF selectbox
                $(document)
                    .on('mousedown', '.jcf-select', function (event) {
                        const $this = $(this);
                        $this.attr({tabindex: 0});
                        $this.siblings('.jcf-hidden').attr('disabled', true);
                        $this.focus();
                    })
                    .on('mouseup', '.jcf-select', function (event) {
                        const $this = $(this);
                        $this.removeAttr('tabindex');
                        $this.siblings('.jcf-hidden').focus();
                        $this.siblings('.jcf-hidden').removeAttr('disabled');
                    });
                $(document).on('keydown', 'select.jcf-hidden', function (event) {
                    if (event.which === 13) {
                        event.preventDefault();
                    } else if (event.which === 27 && $(this).siblings('.jcf-drop-active').length > 0) {
                        event.which = 13;
                        $(this).trigger(event);
                    }
                });

                // Hide on blur
                // note it doesn't work over document selector, event is not fired
                $('select.jcf-hidden').on('blur', function (event) {
                    const $this = $(this);

                    // if key was pressed, than we need to operate with related target, not original target
                    if (event.relatedTarget !== null) {
                        event.target = event.relatedTarget;
                    }

                    const instance = window.jcf.getInstance($this[0]).instance;

                    const target = $(event.target),
                        focusInsideSelect =
                            target.filter(instance.realElement).length ||
                            target.closest(instance.fakeElement).length ||
                            target.closest(instance.dropdown).length;

                    if (!focusInsideSelect) {
                        instance.hideDropdown();
                    }
                });
            },
            buttons: {
                init: function () {
                    this.prepare();
                    // Enable Screen reader standard behavior on space and enter for [role=buttons] to be consistent with normal button element
                    $(document).on('keydown', 'a[role=button]', function (event) {
                        if (event.which === 32 || event.which === 13) {
                            event.preventDefault();
                            $(this).click();
                        }
                    });
                },
                prepare: function () {
                    // Remove HREF=# on a[role=button] as screen-reader would read whole page URL otherwise on focus
                    $('a[role=button]').each(function () {
                        const $this = $(this);
                        let href = $this.attr('href');
                        href = href === '#' ? null : href;
                        const target = $this.data('target');
                        $this.attr({'data-target': target || href, tabindex: 0});
                        if (!href) {
                            $this.removeAttr('href');
                        }
                    });
                },
            },
            range: function () {
                // range slider accessible by keyboard even if it's in slideshow, we want to catch key arrows and stop event propagation
                $('input[type="range"]')
                    .on('keydown', function (event) {
                        const keyCodes = {
                            DOWN: 40,
                            END: 35,
                            HOME: 36,
                            LEFT: 37,
                            RIGHT: 39,
                            UP: 38,
                        };

                        // do nothing for not allowed keys
                        if (!(Object.values(keyCodes).indexOf(event.keyCode) > -1)) return;

                        event.stopPropagation();
                    })
                    .on('mousedown', function (event) {
                        // and catch dragging
                        event.stopPropagation();
                    });
            },
        },
        control: function () {
            $body.on('keypress click', '[class*="-ctrl-field"]', function (e) {
                if (e.which === 13 || e.type === 'click') {
                    e.preventDefault();
                    fieldsCtrl.$wrapper = $(this).closest('.reproducible__wrapper');
                    fieldsCtrl.$toggle = $(this).closest('.reproducible');

                    fieldsCtrl.$terms = $(this).closest('.reproducible__wrapper').find('.reproducible');

                    // LIT-161778 Support for the legacy emails and phones used in account page
                    if ($(fieldsCtrl.container).length === 0) {
                        if ($(this).is('.add-ctrl-field')) {
                            if (fieldsCtrl.$terms.length < fieldsCtrl.maxClone + 1) {
                                fieldsCtrl.on.clone($(this));
                            }
                        } else {
                            if (fieldsCtrl.$terms.length > 1) {
                                fieldsCtrl.on.remove($(this));
                            }
                        }
                    }
                }
            });

            $body.on('click', '[name="markall"]', function (e) {
                fieldsCtrl.on.markAll($(this));
            });
        },
        additionalControls: function () {},
        on: {
            clone: function ($this) {
                window.jcf.destroy($('.reproducible .jcf'));

                fieldsCtrl.$toggle.clone(true, true).find('input').val('').end().appendTo(fieldsCtrl.$wrapper);

                $('.reproducible .jcf').each(function () {
                    window.jcf.replace($(this));
                });

                fieldsCtrl.check.terms($this);

                const $lastTerm = fieldsCtrl.$wrapper.children('.reproducible').length;
                fieldsCtrl.check.lastClone($lastTerm);
            },
            remove: function ($this) {
                fieldsCtrl.$toggle.remove();
                fieldsCtrl.check.terms($this);
                const $lastTerm = fieldsCtrl.$wrapper.children('.reproducible').length;
                fieldsCtrl.check.lastClone($lastTerm);
            },

            markAll: function ($el) {
                fieldsCtrl.$markAll = $el.closest('.markAll');

                if ($el.prop('checked')) {
                    fieldsCtrl.$markAll.find('[type="checkbox"]').prop('checked', true);
                } else {
                    fieldsCtrl.$markAll.find('[type="checkbox"]').prop('checked', false);
                }
            },
        },
        check: {
            terms: function ($this) {
                var before, after;
                const nameInput = $this.closest('.reproducible').find('input').attr('name');
                if (nameInput) {
                    before = nameInput.split('[');
                    after = before[1].split(']');
                }

                // Support for the legacy emails and phones used in account page
                if ($(fieldsCtrl.container).length === 0) {
                    fieldsCtrl.$terms = $('.reproducible');
                } else {
                    fieldsCtrl.$terms = $this.parents(fieldsCtrl.container).find('.reproducible');
                }
                let copy_from_template = 0;
                fieldsCtrl.$terms.each(function (index) {
                    const $el = $(this);

                    if ($el.parents('.template').length) {
                        copy_from_template = 1;
                    } else {
                        const number = index - copy_from_template;
                        $(this)
                            .find('input')
                            .attr('name', before[0] + '[' + number + ']' + after[1]);
                    }
                });
            },
            lastClone: function ($this) {
                if ($this === fieldsCtrl.maxClone) {
                    fieldsCtrl.$wrapper
                        .children('.reproducible:last-child')
                        .children('.add-ctrl-field')
                        .addClass('hidden');
                } else {
                    fieldsCtrl.$wrapper
                        .children('.reproducible:last-child')
                        .children('.add-ctrl-field')
                        .removeClass('hidden');
                }
            },
        },
    };

    UX.fieldsCtrl = fieldsCtrl; // add to global namespace
})();
